import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import history from 'routing/history';
import { resetRequestState } from '../state';

const useNavigateToNextStep = (link, hasError) => {
  const dispatch = useDispatch();
  const { isLoading, requestStarted } = useSelector(
    (state) => state.nomadInsurance.claims
  );

  useEffect(() => {
    if (requestStarted && !isLoading && !hasError) {
      dispatch(resetRequestState());
      history.push(link);
    }
  }, [dispatch, requestStarted, isLoading, hasError, link]);
};

export default useNavigateToNextStep;
